import store from "./store";
import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";

Vue.use(VueCookies);
Vue.$cookies.config("7d");

axios.defaults.baseURL = "https://api.pirls.ir";
axios.defaults.headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json"
};

// check user is login and is admin
const requireAdminAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // check user type
    if (user.type === "ادمین") {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to restricted error page
      next({ name: "Restricted" });
    }
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    axios
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        // check user type
        if (res.data.user.type === "ادمین") {
          // ok, enjoy it ;)
          next();
        } else {
          // send user to restricted error page
          next({ name: "Restricted" });
        }
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Signin" });
      });
  }
};

// check user is login and is school
const requireSchoolAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // check user type
    if (user.type === "مدرسه" || user.type === "ادمین") {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to restricted error page
      next({ name: "Restricted" });
    }
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    axios
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        // check user type
        if (res.data.user.type === "مدرسه" || res.date.user.type === "ادمین") {
          // ok, enjoy it ;)
          next();
        } else {
          // send user to restricted error page
          next({ name: "Restricted" });
        }
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Signin" });
      });
  }
};

// check user is login and is school
const requireAgentAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // check user type
    if (user.type === "نمایندگی" || user.type === "ادمین") {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to restricted error page
      next({ name: "Restricted" });
    }
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    axios
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        // check user type
        if (
          res.data.user.type === "نمایندگی" ||
          res.data.user.type === "ادمین"
        ) {
          // ok, enjoy it ;)
          next();
        } else {
          // send user to restricted error page
          next({ name: "Restricted" });
        }
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Signin" });
      });
  }
};

// check user is login and is school
const requireSuperviosrAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // check user type
    if (user.type === "ناظر" || user.type === "ادمین") {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to restricted error page
      next({ name: "Restricted" });
    }
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    axios
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        // check user type
        if (res.data.user.type === "ناظر" || res.data.user.type === "ادمین") {
          // ok, enjoy it ;)
          next();
        } else {
          // send user to restricted error page
          next({ name: "Restricted" });
        }
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Signin" });
      });
  }
};

// check user is login and is school
const requirePortalAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // check user type
    if (user.type === "پورتال" || user.type === "ادمین") {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to restricted error page
      next({ name: "Restricted" });
    }
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    axios
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        // check user type
        if (res.data.user.type === "پورتال" || res.data.user.type === "ادمین") {
          // ok, enjoy it ;)
          next();
        } else {
          // send user to restricted error page
          next({ name: "Restricted" });
        }
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Signin" });
      });
  }
};

// check user is login
const requireAuth = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // ok, enjoy it ;)
    next();
  } else {
    const token = Vue.$cookies.get("jwt");
    // validation check, browser token
    axios
      .get("/user/checkToken", {
        headers: {
          Authorization: token
        }
      })
      .then(() => {
        // ok, enjoy it ;)
        next();
      })
      .catch(() => {
        // logout user and remove token
        store.dispatch("signoutUser");
        // send user to login page
        next({ name: "Signin" });
      });
  }
};

// check user access to bookPages
const perchasedBook = (to, from, next) => {
  const bookId = to.params.id;
  // validation check, browser token
  // get free books
  axios.get("/books/free").then((res) => {
    const freeBook = res.data.books;
    const hasBook = freeBook.includes(bookId);
    const token = Vue.$cookies.get("jwt");
    // check user access
    if (hasBook) {
      // ok, enjoy it ;)
      next();
    } else {
      // send user to buy message
      axios
        .get("/user/getbooks", {
          headers: {
            Authorization: token
          }
        })
        .then((res) => {
          const userBooks = res.data.books;
          const hasBook = userBooks.includes(bookId);
          // check user books
          if (hasBook) {
            // ok, enjoy it ;)
            next();
          } else {
            axios
              .get("/user/checkToken", {
                headers: {
                  Authorization: token
                }
              })
              .then((userres) => {
                const user = userres.data.user;
                // check user access
                if (
                  user.type === "ادمین" ||
                  user.type === "اپراتور" ||
                  user.type === "تستر"
                ) {
                  // ok, enjoy it ;)
                  next();
                } else {
                  // send user to buy message
                  next({ name: "Buy" });
                }
              });
          }
        })
        .catch(() => {
          // logout user and remove token
          store.dispatch("signoutUser");
          // send user to login page
          next({ name: "Signin" });
        });
    }
  });
};

// check user has exam
const hasNoExam = (to, from, next) => {
  const bookId = to.params.id;
  // clear message state
  store.commit("clearMessageState");
  // validation check, browser token
  const token = Vue.$cookies.get("jwt");
  axios
    .get("/answerSheet/" + bookId, {
      headers: {
        Authorization: token
      }
    })
    .then(() => {
      // ok, enjoy it ;)
      next();
    })
    .catch(() => {
      // set messages
      store.commit("clearMessageState");
      store.commit("setMessageState");
      store.commit("setMessageType", "error");
      store.commit(
        "setMessage",
        "برای مشاهده کارنما و تقدیرنامه ابتدا باید در آزمون شرکت نمایید"
      );
      // to TOP
      window.scrollTo(0, 0);
    });
};

// disable auth page when user login
const loginedUser = (to, from, next) => {
  const user = store.getters.user;
  // check user vuex
  if (user) {
    // redircet to home
    next({ name: "Home" });
  } else {
    const token = Vue.$cookies.get("jwt");
    if (token) {
      axios
        .get("/user/checkToken", {
          headers: {
            Authorization: token
          }
        })
        .then(() => {
          next({ name: "Home" });
        });
    } else {
      next();
    }
  }
};

export {
  requireAdminAuth,
  requireSchoolAuth,
  requireAgentAuth,
  requireSuperviosrAuth,
  requirePortalAuth,
  requireAuth,
  loginedUser,
  perchasedBook,
  hasNoExam
};
